import { render, staticRenderFns } from "./NoBusinessLinkedModal.vue?vue&type=template&id=a68ef4f4&"
import script from "./NoBusinessLinkedModal.vue?vue&type=script&lang=ts&"
export * from "./NoBusinessLinkedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports